import { CONFIG } from '@h2h/shared';
import { ClimbCard } from './ClimbCard';
import { ConfidenceCard } from './ConfidenceCard';
import { CyclingCard } from './CyclingCard';
import { FB_BASE, FB_MAX_LEGS, CY_TOP, DUELS, GOALS_LINE } from './constants';
import { FootballCard } from './FootballCard';
import { OverviewCard } from './OverviewCard';

export const STEPS = [
  {
    eyebrow: 'How it works',
    title: 'Two sports, one ladder',
    body: 'Build cards in football and rank duels in cycling. Lock in before kick-off or the stage start, then climb your division as real results land — free, no real money.',
    Card: OverviewCard
  },
  {
    eyebrow: 'Football',
    title: 'Leagues you already follow',
    body: `A major football tournament is live now; domestic leagues join as their seasons start. Back any matches you fancy — pick the 1X2 base for ${FB_BASE} points, then stack up to ${FB_MAX_LEGS} boosts (BTTS, over/under ${GOALS_LINE}, exact score, scorer and more) that multiply it.`,
    Card: FootballCard
  },
  {
    eyebrow: 'Cycling',
    title: 'Every Grand Tour & Classic',
    body: `From the Tour de France to Paris-Roubaix, each race is its own league. Every stage gives you ${DUELS} rider duels — just call who finishes higher, all ${DUELS}, then climb when the stage settles.`,
    Card: CyclingCard
  },
  {
    eyebrow: 'Build your card',
    title: 'Base plus boosts',
    body: `Land the 1X2 base and every boost you stacked multiplies your ${FB_BASE} points — miss the base and the whole card busts to −${FB_BASE}. In cycling you rank ${DUELS} duels instead; your boldest call scores ×${CY_TOP}.`,
    Card: ConfidenceCard
  },
  {
    eyebrow: 'Promotion',
    title: 'Climb the divisions',
    body: `Every league is its own world. Finish in the top ${CONFIG.PROMOTE_COUNT} of your ${CONFIG.DIVISION_SIZE}-player division to go up; the bottom ${CONFIG.RELEGATE_COUNT} drop. The ladder resets every round, so you're always one round from climbing.`,
    Card: ClimbCard
  }
] as const;
